<template>
    <div class="">
        <el-popover placement="top" v-model="visible">
            <div v-loading="loading" style="display: flex;padding:0 20px;gap:20px;align-items: center;">
                <el-link type="info" v-if="password" :underline="false">{{ password }}</el-link>
                <el-link type="warning" v-else :underline="false">暂无可查看密码，如需查看，请先修改密码</el-link>

                <el-button type="primary" v-if="password" size="mini" @click="copyText(password)">复制</el-button>
            </div>
            <el-button size="small" slot="reference" v-permission="'User:ViewPassword'" @click="_userGet"
                style="margin-left: 10px;">查看密码</el-button>
        </el-popover>
    </div>
</template>

<script>
import { _userGet } from '@/api/companyManagement/Company'
import { set } from 'lodash'
export default {
    name: "",
    props: {
        row: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {
            visible: false,
            password: '',
            loading: true
        }
    },
    methods: {
        async _userGet() {
            this.loading = true
            let res = await _userGet({
                T_uuid: this.row.T_uuid
            })
            if (res.data.Code == 200) {
                this.password = res.data.Data.T_pass_str
            }
            setTimeout(() => {
                this.loading = false
            }, 500)
        },
        copyText(text) {
            // 创建临时textarea元素
            const textArea = document.createElement('textarea');
            textArea.value = text;
            document.body.appendChild(textArea);
            textArea.select();

            try {
                // 执行复制命令
                document.execCommand('copy');
                this.$message({
                    message: '密码复制成功',
                    type: 'success'
                })
            } catch (err) {
                this.$message({
                    message: '密码复制失败',
                    type: 'error'
                })
            }

            // 清理DOM
            document.body.removeChild(textArea);
        },
    }
}
</script>
<style lang="scss">
/* @import url(); 引入css类 */
</style>